import React from 'react';
import { Link } from "react-router-dom";

// import { ReactComponent as LogoWhite } from "../../../Assets/Logo/logo-white.svg";
// import { ReactComponent as LogoBlue } from "../../../Assets/Logo/logo-blue.svg";
import './Logo.scss';
import LogoBlue from './LogoBlue';
import WhiteLogo from './LogoWhite';

const Logo = (props) => {
  let logo = <WhiteLogo className="logoimg"/>;
  if (props.scrolled) logo = <LogoBlue  className="logoimg"/>;
  return (
    <Link to="/" className="logo" id="logo">
      {logo}
    </Link>
  );
};

export default Logo;

